<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :beforeSetupGrid="beforeSetupGrid"
            :expandedOptions="{
                enabled: true,
                template: 'student-call-details',
            }"
        ></dx-grid>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Calls",

        userBranch: "",
        url: "",
        columns: [
            {
                field: "phoneLineIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value, row) => {
                    switch (value) {
                        case "PARENTS LINE":
                            return "mdi-phone-incoming";
                        case "STUDENTS LINE":
                            return "mdi-phone-outgoing";
                        case "TEACHERS LINE":
                            return "mdi-account";
                        default:
                            return "";
                    }
                },
                iconColor: (value, row) => {
                    switch (value) {
                        case "PARENTS LINE":
                            return "#007827";
                        case "STUDENTS LINE":
                            return "#27a4d9";
                        case "TEACHERS LINE":
                            return "#11b99a";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                label: "Father",
                field: "father",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father Hebrew",
                field: "fatherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Employee ID",
                field: "employeeID",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Family ID",
                field: "familyID",
                link: "Account View",
                format: "",
                //template: "link-action-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                //template: "utc-to-est-template",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(moment()),
                selectedFilterOperation: "=",
            },
            {
                label: "Duration",
                field: "duration",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Minutes",
                field: "minutes",
                visible: false,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "From",
                field: "from",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "To",
                field: "to",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Action",
                field: "lastAction",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Boot Number",
                field: "bootNumber",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Phone Line",
                field: "phoneLine",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Phone Type",
                field: "phoneType",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Outbound Call Blocked",
            //     field: "outboundCallBlocked",
            //     visible: false,
            //     type: "boolean",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            // {
            //     label: "Blocked By Schedule",
            //     field: "blockedBySchedule",
            //     visible: false,
            //     type: "boolean",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
        ],
    }),
    created() {
        // this.columns.find(
        //     (c) => c.field == "familyID"
        // ).linkAction = this.onAccountIDClicked;
    },
    methods: {
        beforeSetupGrid() {
            this.userBranch = this.$store.state.authentication.branch;

            //this.columns.find((c) => c.field == "branch").filterValue = "MYF";

            this.url =
                "schoolCalls?" +
                (this.userBranch != "null"
                    ? "branch=" + this.userBranch
                    : "branch=") +
                "&employeeID=";
            //this.url = "campCalls?branch=MYF";

            //this.url = "campCalls?";
        },
        async onRowClicked(call) {},
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.action-tile .v-list__tile {
    height: 65px;
}
</style>
